// src/analytics.js
import ReactGA from "react-ga4";

// export const initGA = () => {
//     ReactGA.initialize("G-22YJ0F86YW"); // Replace with your GA4 Measurement ID
// };

export const logPageView = (path = window.location.pathname) => {
    ReactGA.send({ hitType: "pageview", page: path });
};

export const logEvent = (category, action, label) => {
    ReactGA.event({
        category,
        action,
        label,
    });
};
